import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router';

import BlockWrapper from '../../components/blocks/BlockWrapper';
import GenericBlock from '../../components/blocks/GenericBlock';

class NotFound extends Component {

    back() {
        window.history.back();
    }

    render() {
        document.title = 'TROI Studio | Not Found';

        return (
            <div>
                <BlockWrapper>
                    <GenericBlock>
                        <Col md={12}>
                            <h1>Oops...</h1>
                            <p>The page you are trying to access does not exist</p>
                            <p>Please go <a href="#" onClick={this.back}>back to where you came from</a> or <Link to="/">return to the homepage</Link></p>
                        </Col>
                    </GenericBlock>
                </BlockWrapper>
            </div>
       );
    }

}

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/errors/NotFound.js